/**
 * Search color switches
 */
var productList = document.querySelector('.ProductList');
new window.ProductItemColorSwatch(productList);

/**
 * Initial Collection Colors
 */
$('.ProductItem').each(function() {
  var $item = $(this);

  var $selectedInput = $item.find('.ColorSwatch__Radio:checked');
  var variantUrl = $selectedInput.attr('data-variant-url');

  console.log('variantUrl', variantUrl);

  $item.find('.ProductItem__Title > a').attr('href', variantUrl);
  $item.find('.ProductItemSlider a').attr('href', variantUrl);
  $item.find('.ProductItemImages a').attr('href', variantUrl);

  var selectedColor = $selectedInput.data('color-handle');
  handleColorSwitchImages($item, selectedColor);
});
